import { render, staticRenderFns } from "./CompetitionEntryCounts.vue?vue&type=template&id=713f2ea5&"
import script from "./CompetitionEntryCounts.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEntryCounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports